{
  "empty": "Пока нет лидов",
  "noMatch": "Под эти фильтры ничего не попало",
  "columns": {
    "created": "Время",
    "type": "Тип",
    "country": "Страна",
    "reason": "Причина",
    "ip": "IP",
    "source": "Источник"
  },
  "filters": {
    "search": "IP",
    "served": "Страница"
  },
  "type": {
    "lead": "Лид",
    "white": "White",
    "black": "Black",
    "bot": "Бот",
    "abuse": "Абуз"
  },
  "detail": {
    "title": "Лид",
    "groups": {
      "classification": "Классификация",
      "geo": "Гео",
      "device": "Устройство",
      "network": "Сеть",
      "headers": "Заголовки"
    },
    "fields": {
      "type": "Тип",
      "blockReason": "Причина блокировки",
      "page": "Страница",
      "domain": "Домен",
      "uri": "URI",
      "source": "Источник",
      "country": "Страна",
      "city": "Город",
      "lang": "Язык",
      "deviceType": "Тип устройства",
      "deviceOs": "ОС",
      "ip": "IP",
      "isp": "ISP",
      "isVpn": "VPN",
      "dns": "DNS",
      "referer": "Referer",
      "userAgent": "User-Agent",
      "acceptLanguage": "Accept-Language",
      "xForwardedFor": "X-Forwarded-For",
      "utms": "UTM",
      "secChUa": "Sec-CH-UA",
      "secChUaPlatform": "Платформа",
      "secFetchSite": "Fetch-Site",
      "secChUaMobile": "Sec-CH-UA-Mobile",
      "secFetchMode": "Fetch-Mode",
      "secFetchDest": "Fetch-Dest",
      "campaign": "Кампания"
    },
    "yes": "Да",
    "no": "Нет"
  },
  "blockReason": {
    "ua": "User-Agent",
    "ip_blocked": "IP в чёрном списке",
    "abuse_ip": "IP с плохой репутацией",
    "isp": "ISP в чёрном списке",
    "vpn": "VPN-сеть",
    "dns": "Обратный DNS",
    "campaign_dns": "Обратный DNS кампании",
    "country": "Страна вне списка",
    "language": "Язык вне списка",
    "device": "Устройство вне списка",
    "os": "ОС вне списка",
    "source": "Источник выключен",
    "white_only": "Режим «Только white»"
  },
  "page": {
    "white": "White",
    "black": "Black"
  }
}
